import { Check } from 'lucide-react';
import ArrowLink from './ArrowLink';
import Reveal from './Reveal';
import { trackEvent } from '../lib/analytics';

export default function PackageCard({ pkg, delay = 0 }) {
  const recommended = pkg.recommended;
  return (
    <Reveal delay={delay} className="h-full">
      <article
        data-testid={`package-card-${pkg.slug}`}
        className={`relative flex h-full flex-col rounded-2xl border p-7 transition-[transform,border-color,box-shadow] duration-300 hover:-translate-y-1 sm:p-8 ${
          recommended
            ? 'border-charcoal bg-charcoal text-offwhite shadow-[0_24px_60px_-24px_rgba(36,39,33,0.45)]'
            : 'border-hairline bg-white text-charcoal hover:border-charcoal/30 hover:shadow-[0_24px_50px_-30px_rgba(36,39,33,0.25)]'
        }`}
      >
        {recommended && (
          <span className="absolute -top-3.5 left-7 rounded-full bg-lime px-4 py-1.5 font-mono text-[11px] font-semibold uppercase tracking-[0.15em] text-charcoal">
            Recommended
          </span>
        )}
        <h3 className="font-heading text-xl font-bold tracking-tight sm:text-2xl">{pkg.name}</h3>
        <p className={`mt-2 text-sm leading-relaxed ${recommended ? 'text-offwhite/70' : 'text-stonebrand'}`}>
          {pkg.description}
        </p>
        <p className="mt-6 flex items-baseline gap-2">
          <span className="font-heading text-4xl font-extrabold tracking-tight sm:text-5xl" data-testid={`package-price-${pkg.slug}`}>
            {pkg.price}
          </span>
          <span className={`text-sm ${recommended ? 'text-offwhite/60' : 'text-stonebrand'}`}>{pkg.period}</span>
        </p>
        <ul className={`mt-7 flex-1 space-y-3 border-t pt-7 ${recommended ? 'border-charcoal-line' : 'border-hairline'}`}>
          {pkg.features.map((f, i) => (
            <li key={i} className="flex gap-3 text-sm leading-relaxed">
              <Check
                className={`mt-0.5 h-4 w-4 shrink-0 ${recommended ? 'text-lime' : 'text-charcoal'}`}
                aria-hidden="true"
              />
              <span className={recommended ? 'text-offwhite/85' : 'text-charcoal/85'}>{f}</span>
            </li>
          ))}
        </ul>
        {pkg.finePrint && (
          <p className={`mt-6 text-xs leading-relaxed ${recommended ? 'text-offwhite/50' : 'text-stonebrand'}`}>
            {pkg.finePrint}
          </p>
        )}
        <div className="mt-7">
          <ArrowLink
            to={`/contact?package=${pkg.slug}`}
            variant={recommended ? 'lime' : 'dark'}
            className="w-full"
            testid={`package-cta-${pkg.slug}`}
            onClick={() => trackEvent('select_package', { package: pkg.slug })}
          >
            Request This Package
          </ArrowLink>
        </div>
      </article>
    </Reveal>
  );
}
